import { useSelector, shallowEqual } from 'react-redux';
import { useMaskPII } from 'hooks/useMaskPII';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { NsPrice } from 'components/common/ns-price/NsPrice';

import { getFuelValue } from 'components/direct-sales/fuel-type/getFuelValue';
import { useCurrentProduct } from 'components/direct-sales/quote/hooks/useCurrentProduct';
import { useExitFeeValue } from 'components/direct-sales/quote/hooks/useExitFees';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { FUEL_OPTIONS } from 'config/app-config';
import { formatTariffDate } from 'components/direct-sales/quote/utils';
import { capitalize } from 'utils/misc';

export const testId = 'basketTestId';

export const Basket = () => {
  const { mask } = useMaskPII();
  const product = useCurrentProduct();

  const fuelType = useSelector(selectFuelType, shallowEqual);
  const selectedFuelType =
    getFuelValue(fuelType) === FUEL_OPTIONS.DUAL
      ? 'Gas & Electricity'
      : capitalize(getFuelValue(fuelType));

  const address = useSelector(selectedAddress, shallowEqual) || {};

  const { productName, tariffEndsOn, monthlyAmount, annualAmount } = product;

  const { short: exitFee } = useExitFeeValue(product);

  return (
    <NsContent data-testid={testId}>
      <NsCard>
        <h3>{productName}</h3>
        <NsDescriptionList className="dl-stack">
          {[
            {
              term: 'Quote for address',
              description: (
                <p {...mask} data-testid="address">
                  {address?.displayName},{' '}
                  <span {...mask}>{address?.postcode}</span>
                </p>
              )
            },
            {
              term: 'Energy type',
              description: selectedFuelType
            },
            {
              term: 'Contract ends',
              description: tariffEndsOn
                ? formatTariffDate(tariffEndsOn)
                : 'Not Applicable'
            },
            {
              term: 'Exit fee',
              description: exitFee
            },
            {
              term: 'Estimated costs (inc. VAT)',
              description: (
                <p>
                  <span className="h2">
                    <NsPrice amount={monthlyAmount} />{' '}
                  </span>
                  / month
                  <br />
                  <NsPrice amount={annualAmount} /> / year
                </p>
              )
            }
          ]}
        </NsDescriptionList>
      </NsCard>

      <NsCard heading="You’re in control" decoration="rosette-tick-green">
        If we offer a cheaper tariff, you can make the switch any time -{' '}
        <strong>free</strong>.
      </NsCard>
    </NsContent>
  );
};

export default Basket;
